import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import UserNewForm from 'components/forms/clients/UserNewForm';

class UserNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initClose: false,
    };
  }

  close = () => {
    this.setState(prevState => ({ initClose: !prevState.initClose }));
  };

  doClose = () => {
    this.setState({ initClose: false });
    const { close } = this.props;
    close();
  };

  render() {
    const {
      intl: { messages },
      show,
      onSubmitParent,
    } = this.props;
    const { initClose } = this.state;

    return (
      <Modal show={show} onHide={this.close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_user}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class={initClose ? 'hide' : ''}>
            <UserNewForm onSubmitParent={onSubmitParent} clientData={this.props.clientData}/>
          </div>

          {initClose ? (
            <div>
              <h2 class="text-center">{messages.really_cancel}</h2>
              <p class="hint-text text-center">{messages.unsaved_information_will_be_lost}</p>
              <div class="text-center m-b-25">
                <Button
                  bsStyle="primary"
                  bsSize="lg"
                  class="m-b-20"
                  onClick={() => this.setState({ initClose: false })}
                >
                  {messages.no}
                </Button>
              </div>
              <div class="text-center">
                <Button bsStyle="danger" onClick={this.doClose}>
                  {messages.yes}
                </Button>
              </div>
            </div>
          ) : null}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(UserNew)));
